export var appFramework = function appFramework(_config, _data, globalConfig) {
  if (!globalConfig.app.framework) {
    return null;
  }
  return {
    'app:framework:name': globalConfig.app.framework.name,
    'app:framework:version': globalConfig.app.framework.version
  };
};